export default __webpack_public_path__ + "static/media/spring.20b13b20.jpg";